var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessSnackbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C10 14.4772 14.4772 10 20 10C22.6522 10 25.1957 11.0536 27.0711 12.9289C28.9464 14.8043 30 17.3478 30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20ZM19.73 23.61L24.3 17.61V17.58C24.5179 17.2942 24.5668 16.9138 24.4283 16.5822C24.2897 16.2505 23.9848 16.018 23.6283 15.9722C23.2718 15.9264 22.9179 16.0742 22.7 16.36L18.92 21.36L17.29 19.28C17.0703 18.9978 16.7167 18.8542 16.3624 18.9033C16.0081 18.9525 15.707 19.1869 15.5724 19.5183C15.4378 19.8497 15.4903 20.2278 15.71 20.51L18.15 23.62C18.3408 23.8615 18.6322 24.0017 18.94 24C19.2495 23.9993 19.5412 23.8552 19.73 23.61Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSnackbarIcon);
export default __webpack_public_path__ + "static/media/SuccessSnackbarIcon.1393f0193de7f03c5b9c1475cf71d617.svg";
export { ForwardRef as ReactComponent };